// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The parameter type
 */
export type ParameterType = 'air' | 'water_intake' | 'water_discharge' | 'residue' | 'energy';

export const ParameterType = {
    air: 'air' as ParameterType,
    water_intake: 'water_intake' as ParameterType,
    water_discharge: 'water_discharge' as ParameterType,
    residue: 'residue' as ParameterType,
    energy: 'energy' as ParameterType
};

